import React, { memo } from 'react';

import RichTextArea from '../../../design-system/RichTextArea/RichTextArea';

const BodyContentField = ({ value, feedbackAllowed, logFeedbackTrigger }) => {
    return (
        <div className="flex gap-2 items-start">
            <div className="flex-1">
                <RichTextArea
                    value={value}
                    previewOnly
                    autoExpand
                    isBorderHidden
                    openLinksInNewTab
                />
            </div>

            {feedbackAllowed && logFeedbackTrigger}
        </div>
    );
};

export default memo(BodyContentField);
